var map = {
	"./1/course.png": 2484,
	"./courseimages/1.jpg": 1054,
	"./courseimages/2.jpg": 196,
	"./courseimages/200.jpg": 8788,
	"./courseimages/3.jpg": 6697,
	"./courseimages/5.jpg": 2104,
	"./demo/pdf/hypothesistesting.pdf": 4321,
	"./demo/pdf/meanmedmode.pdf": 4659,
	"./demo/pdf/meanmedmode2.pdf": 8341,
	"./demo/pdf/measuresofspread.pdf": 596,
	"./demo/pdf/pca.pdf": 1198,
	"./demo/pdf/pdf.pdf": 4448,
	"./demo/pdf/probability.pdf": 5475,
	"./demo/pdf/t_test.pdf": 482,
	"./demo/pdf/unimulti.pdf": 3660,
	"./evo1/image/FT4-11.JPG": 3593,
	"./evo1/image/FT5-1.JPG": 459,
	"./evo1/image/FT5-10.JPG": 11,
	"./evo1/image/FT5-14.JPG": 3976,
	"./evo1/image/FT5-2.JPG": 3623,
	"./evo1/image/FT5-3.JPG": 8374,
	"./evo1/image/FT5-4.JPG": 9167,
	"./evo1/image/FT5-5.JPG": 5842,
	"./evo1/image/FT5-6.JPG": 89,
	"./evo1/image/FT5-7.JPG": 9243,
	"./evo1/image/FT5-8.JPG": 6908,
	"./evo1/image/FT5-9.JPG": 164,
	"./evo1/image/bookcover_campbell.jpg": 9901,
	"./evo1/image/test1-1.png": 9211,
	"./evo1/image/test1-2.png": 7335,
	"./evo1/image/test1-3.png": 1613,
	"./evo1/image/test1-4.png": 8986,
	"./evo1/pdf/Factsheet Evolutie door Selectie-juli2022.pdf": 5927,
	"./evo1/pdf/Factsheet Evolutie door Toeval - juli2022.pdf": 2347,
	"./evo1/pdf/Factsheet Fylogenie-Misconcepten-juli2022.pdf": 528,
	"./evo1/pdf/Factsheet Fylogenie-juli2022.pdf": 4406,
	"./evo1/pdf/Factsheet Natural selection & Misconceptions-juli2022.pdf": 5449,
	"./evo1/pdf/Factsheet Soortvorming-juli2022.pdf": 693,
	"./evo1/pdf/Misconceptions in Evolution&Biology-juli2022.pdf": 6928,
	"./evo3/factsheets/Factsheet Evolutie door Selectie-juli2022.pdf": 7241,
	"./evo3/factsheets/Factsheet Evolutie door Toeval - juli2022.pdf": 6890,
	"./evo3/factsheets/Factsheet Fylogenie-Misconcepten-juli2022.pdf": 103,
	"./evo3/factsheets/Factsheet Fylogenie-juli2022.pdf": 7305,
	"./evo3/factsheets/Factsheet Natural selection & Misconceptions-juli2022.pdf": 6203,
	"./evo3/factsheets/Factsheet Soortvorming-juli2022.pdf": 2071,
	"./evo3/factsheets/Misconceptions in Evolution&Biology-juli2022.pdf": 4581,
	"./evo3/test1-1.png": 8397,
	"./evo3/test1-2.png": 8101,
	"./evo3/test1-3.png": 4570,
	"./evo3/test1-4.png": 3393,
	"./logo.png": 6949,
	"./logo.svg": 9574,
	"./pdfs/testing_pdf.pdf": 4907,
	"./success": 6655,
	"./success.json": 6655,
	"./utils/image-not-found.png": 5649
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;